import React from 'react';
import ErrorBox from '../../../../ui/pages/Common/ErrorBox';
import { TestIdIdentifier } from '../../../../util/identifiers/identifiers.util';
import { FlexPane } from '../FlexPane/FlexPane';
import { Tab, TabProps, Tabs } from '../../../../ui/components/Tabs';

interface PaneProps {
  children: React.ReactNode;
  tabs?: TabProps[];
  testId?: TestIdIdentifier;
  overflow?: 'auto';
  error?: string;
}

export default function Pane({ children, tabs, testId, overflow, error }: PaneProps) {
  return (
    <FlexPane
      spacing={0}
      className={`pane content-x content-y-screen`}
      testId={testId}
      overflow={overflow}
      contentOverflow={overflow === 'auto' ? 'visible' : 'hidden'}
      header={
        tabs?.length ? (
          <Tabs>
            {tabs.map(t => (
              <Tab key={t.key} {...t} />
            ))}
          </Tabs>
        ) : undefined
      }
      content={
        <div className='flex h-full w-full flex-col'>
          <ErrorBox error={error} />
          {children}
        </div>
      }
    />
  );
}
